import React from 'react';
import Banner from '../components/common/Banner';

const EventsPage = () => {
  return (
    <div className="h-full w-full  fade-in">
      <Banner 
        title="Events & Happenings"
        subtitle="Campus Life | Student Activities | Community Engagement"
        imageSrc="https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
      />
      <div className="max-w-6xl mx-auto p-4 sm:p-6 md:p-10 space-y-8 sm:space-y-12">
        
        <div className="mb-6 sm:mb-8">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Events & Happenings</h2>
          <p className="text-gray-500">Celebrating achievements, learning, and community engagement through various campus activities.</p>
        </div>

        {/* Students Trip */}
        <section>
          <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <h3 className="text-xl sm:text-2xl font-bold text-crimson mb-4 sm:mb-6 flex items-center">
              <i className="fas fa-bus mr-3"></i>
              Educational Trips & Field Visits
            </h3>
            
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-6">
              <div className="bg-gray-100 p-4 rounded-lg h-48 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-camera text-4xl mb-2"></i>
                  <p className="text-sm">Industrial Visit Photos</p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg h-48 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-camera text-4xl mb-2"></i>
                  <p className="text-sm">Technical Tour Gallery</p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg h-48 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-camera text-4xl mb-2"></i>
                  <p className="text-sm">Study Tour Highlights</p>
                </div>
              </div>
            </div>
            
            <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
              Our students regularly participate in educational trips and industrial visits to leading companies and research 
              institutions. These experiences provide practical exposure to real-world applications of theoretical knowledge 
              and help students understand industry practices and technological advancements.
            </p>
          </div>
        </section>

        {/* Tree Plantation */}
        <section>
          <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <h3 className="text-xl sm:text-2xl font-bold text-crimson mb-4 sm:mb-6 flex items-center">
              <i className="fas fa-tree mr-3"></i>
              Environmental Initiatives - Tree Plantation
            </h3>
            
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 items-center">
              <div className="space-y-4">
                <div className="bg-gray-100 p-4 rounded-lg h-64 flex items-center justify-center">
                  <div className="text-center text-gray-500">
                    <i className="fas fa-camera text-5xl mb-3"></i>
                    <p>Tree Plantation Drive Photos</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-4">
                <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                  As part of our commitment to environmental sustainability, FiT Engineering College regularly organizes tree 
                  plantation drives. These initiatives involve students, faculty, and staff working together to create 
                  a greener campus and contribute to environmental conservation.
                </p>
                
                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                  <h4 className="font-semibold text-green-800 mb-2">Green Initiative Impact</h4>
                  <div className="grid grid-cols-2 gap-4 text-green-700 text-center">
                    <div>
                      <div className="text-2xl font-bold">500+</div>
                      <div className="text-sm">Trees Planted</div>
                    </div>
                    <div>
                      <div className="text-2xl font-bold">20+</div>
                      <div className="text-sm">Drives Organized</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Tab Distributions */}
        <section>
          <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <h3 className="text-xl sm:text-2xl font-bold text-crimson mb-4 sm:mb-6 flex items-center">
              <i className="fas fa-tablet-alt mr-3"></i>
              Digital Learning Initiative - Device Distribution
            </h3>
            
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 items-center">
              <div className="space-y-4">
                <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                  To enhance digital learning and ensure equal access to educational resources, the institute has 
                  undertaken a comprehensive device distribution program. Students receive tablets and digital learning 
                  tools to support their academic journey and bridge the digital divide.
                </p>
                
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <h4 className="font-semibold text-blue-800 mb-2">Digital Learning Benefits</h4>
                  <ul className="text-blue-700 text-sm space-y-1">
                    <li>• Access to digital textbooks and resources</li>
                    <li>• Interactive learning applications</li>
                    <li>• Online assessment and feedback systems</li>
                    <li>• Virtual laboratory simulations</li>
                  </ul>
                </div>
              </div>
              
              <div className="bg-gray-100 p-4 rounded-lg h-64 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-camera text-5xl mb-3"></i>
                  <p>Device Distribution Ceremony Photos</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Yoga Day */}
        <section>
          <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <h3 className="text-xl sm:text-2xl font-bold text-crimson mb-4 sm:mb-6 flex items-center">
              <i className="fas fa-meditation mr-3"></i>
              International Yoga Day Celebration
            </h3>
            
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-6">
              <div className="bg-gray-100 p-4 rounded-lg h-40 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-camera text-4xl mb-2"></i>
                  <p className="text-sm">Morning Session</p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg h-40 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-camera text-4xl mb-2"></i>
                  <p className="text-sm">Group Activities</p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg h-40 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-camera text-4xl mb-2"></i>
                  <p className="text-sm">Meditation Session</p>
                </div>
              </div>
            </div>
            
            <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
              Every year, our institute celebrates International Yoga Day with enthusiasm and participation from the entire 
              campus community. These sessions promote physical and mental well-being, stress management, and mindfulness 
              among students and faculty members.
            </p>
          </div>
        </section>

        {/* Sports */}
        <section>
          <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <h3 className="text-xl sm:text-2xl font-bold text-crimson mb-4 sm:mb-6 flex items-center">
              <i className="fas fa-trophy mr-3"></i>
              Sports & Athletic Activities
            </h3>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-6">
              <div className="bg-gray-100 p-4 rounded-lg h-40 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-football-ball text-3xl mb-2"></i>
                  <p className="text-sm">Football Tournament</p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg h-40 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-basketball-ball text-3xl mb-2"></i>
                  <p className="text-sm">Basketball Championship</p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg h-40 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-running text-3xl mb-2"></i>
                  <p className="text-sm">Athletic Meet</p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg h-40 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <i className="fas fa-medal text-3xl mb-2"></i>
                  <p className="text-sm">Award Ceremony</p>
                </div>
              </div>
            </div>
            
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
              <div>
                <p className="text-gray-600 leading-relaxed mb-4 text-sm sm:text-base">
                  Sports play a vital role in the overall development of our students. The institute encourages 
                  participation in various sports activities and regularly organizes tournaments, championships, 
                  and fitness programs to promote a healthy and active lifestyle.
                </p>
                
                <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                  <h4 className="font-semibold text-yellow-800 mb-2">Sports Facilities</h4>
                  <ul className="text-yellow-700 text-sm space-y-1">
                    <li>• Multi-purpose sports ground</li>
                    <li>• Indoor games facility</li>
                    <li>• Fitness and gymnasium</li>
                    <li>• Professional coaching support</li>
                  </ul>
                </div>
              </div>
              
              <div>
                <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
                  <h4 className="font-semibold text-orange-800 mb-2">Recent Achievements</h4>
                  <ul className="text-orange-700 text-sm space-y-1">
                    <li>• University level football championship winners</li>
                    <li>• Regional basketball tournament runners-up</li>
                    <li>• Inter-college athletics meet participation</li>
                    <li>• District level badminton competition</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section>
          <div className="bg-slate-50 p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray text-center">
            <h3 className="text-xl sm:text-2xl font-serif font-bold text-slate mb-3 sm:mb-4">Stay Connected</h3>
            <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">
              Don't miss out on our latest events and activities. Follow us on social media for regular updates.
            </p>
            <div className="flex justify-center gap-3 sm:gap-4 flex-wrap">
              <a href="#" className="bg-crimson hover:bg-red-800 text-white p-3 rounded-full transition">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="bg-crimson hover:bg-red-800 text-white p-3 rounded-full transition">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="bg-crimson hover:bg-red-800 text-white p-3 rounded-full transition">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="#" className="bg-crimson hover:bg-red-800 text-white p-3 rounded-full transition">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default EventsPage;